import React from 'react'

import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Input } from '@/shared/components/atoms/Input'
import { Label } from '@/shared/components/atoms/Label/Label'

import { BillingInformationFormData } from '../BillingInformation.types'

export const DefaultAddressFields: React.FC = () => {
	const { t } = useTranslation('common')
	const {
		register,
		formState: { errors },
	} = useFormContext<BillingInformationFormData>()

	return (
		<>
			{/* State */}
			<div className="flex flex-col gap-2">
				<Label htmlFor="state">
					{t('account.billing_information.state')} *
				</Label>
				<Input
					id="state"
					{...register('state')}
					className="bg-input"
					aria-invalid={!!errors.state}
				/>
				{errors.state && (
					<p className="text-sm text-destructive">{errors.state.message}</p>
				)}
			</div>

			{/* City */}
			<div className="flex flex-col gap-2">
				<Label htmlFor="city">{t('account.billing_information.city')} *</Label>
				<Input
					id="city"
					{...register('city')}
					className="bg-input"
					aria-invalid={!!errors.city}
				/>
				{errors.city && (
					<p className="text-sm text-destructive">{errors.city.message}</p>
				)}
			</div>

			{/* ZIP Code */}
			<div className="flex flex-col gap-2">
				<Label htmlFor="zip">{t('account.billing_information.zip')} *</Label>
				<Input
					id="zip"
					{...register('zip')}
					className="bg-input"
					aria-invalid={!!errors.zip}
				/>
				{errors.zip && (
					<p className="text-sm text-destructive">{errors.zip.message}</p>
				)}
			</div>
		</>
	)
}
